import subjectForm from "@/core/services/forms/subjectForm.js";
import { INIT_FORM } from "@/core/services/store/form.module.js";

export default {
  methods: {
    /**
     * Init subject form with default values from subjectForm object and open subject form element
     * @param {Object|null} fields
     * @return {void}
     */
    createSubject(fields = null) {
      let form = JSON.parse(JSON.stringify(subjectForm));
      if (fields) {
        for (const [key, value] of Object.entries(fields)) {
          form.fields[key] = value;
        }
      }
      this.$store.dispatch(INIT_FORM, form);
      if (this.$refs.subjectFormModal) {
        this.$refs.subjectFormModal.show();
      }
    },

    /**
     * Init subject form with edit mode and open subject form element
     * @param {Object} subject
     * @return {void}
     */
    editSubject(subject) {
      console.log('subject');
      console.log(subject);
      let form = JSON.parse(JSON.stringify(subjectForm));
      form.mode = "edit";
      form.path = form.path + "/" + subject.id;
      for (const [key, value] of Object.entries(subject)) {
        form.fields[key] = value;
      }
      form.fields._method = "PUT";
      form.fields = this.updateSubjectFormFields(form.fields, subject);
      form.helpers.clientOptions = [
        {
          id: subject.client.id,
          text: subject.client.full_name,
          type: subject.client.entity_type,
          value: `${subject.client.entity_type}_${subject.client.id}`
        } 
      ]
      form.helpers.subjectTypeOptions = [
        {
          text: subject.type,
          value: subject.type,
        }
      ]
      this.$store.dispatch(INIT_FORM, form);
      if (this.$refs.subjectFormModal) {
        this.$refs.subjectFormModal.show();
      }
    },

    /**
     * Update form fields object
     * @param {Object} formFields
     * @param {Object} subject
     * @return {Object}
     */
     updateSubjectFormFields(formFields, subject) {
      formFields.subjectableId = `${subject.client.entity_type}_${subject.client.id}`
      formFields.subjectableType = subject.client.entity_type
      return formFields;
    }
  }
};
